var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bread-box"},[_vm._m(0),_c('el-breadcrumb',{staticClass:"breadcrumb",attrs:{"separator-class":"el-icon-arrow-right"}},_vm._l((_vm.breadcrumbs),function(item){return _c('el-breadcrumb-item',{key:item.name,attrs:{"to":item.path}},[_vm._v(_vm._s(item.name))])}),1)],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('span',[_c('i',{staticClass:"el-icon-location-information"}),_vm._v("您当前所在位置：")])
}]

export { render, staticRenderFns }